module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/MK-7f69dc1689f7575cc7ba563c36508993.png";